import { createSelector } from 'reselect'

const getChildRegisters = (state) => state.childRegisters

export const getChildRegistersStatistics = createSelector([getChildRegisters], (state) => state.statistics)

export const getChildRegistersStatisticsData = createSelector([getChildRegistersStatistics], (state) => state.data)
